export const pricing = {
  traditionalNotary: {
    perStamp: 10,
    perSigner: 10,
  },
  eNotary: {
    perStamp: 20,
    perSigner: 20,
    platformFeeNote: 'Additional BlueNotary or platform fees may apply.',
  },
  loanSigning: 300,
  trustEstateSigning: 300,
  i9Verification: 30,
  fieldInspections: {
    occupancyVerification: 20,
    insuranceAudit: 100,
    commercialInspection: 150,
    delinquencyInterview: 100,
    leasedEquipmentInspection: 50,
  },
  certifiedCopy: 20,
  apostilleAssistance: {
    fullPackageBase: 200,
    fullPackagePerDocument: 20,
    limitedPerDocument: 20,
  },
} as const

export const formatCurrency = (amount: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(amount)
